import ComponentDocs from './ComponentDocs';

export default ComponentDocs;
